module.exports = __webpack_public_path__ + "static/img/6.a1b96aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/sp/6.png
// module id = Ru5y
// module chunks = 0